export const addressesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'addressTypeDesc',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'address1',
    label: 'Address 1',
    sortable: false,
  },
  {
    name: 'address2',
    label: 'Address 2',
    sortable: false,
  },
  {
    name: 'city',
    label: 'City',
    sortable: false,
  },
  {
    name: 'country',
    label: 'Country',
    sortable: false,
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    sortable: false,
  },
  {
    name: 'isoStandard',
    label: 'ISO',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];

export const aliasesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'aliasTypeDesc',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'name',
    label: 'Name',
    sortable: false,
  },
  {
    name: 'englishDescription',
    label: 'Script',
    sortable: false,
  },
  {
    name: 'firstName',
    label: 'First',
    sortable: false,
  },
  {
    name: 'lastName',
    label: 'Last',
    sortable: false,
  },
  {
    name: 'middleName',
    label: 'Middle',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];

export const countryAssociationsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'associationTypeDesc',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'administrativeUnitName',
    label: 'Country',
    sortable: false,
  },
  {
    name: 'isoStandard',
    label: 'ISO',
    sortable: false,
  },
  {
    name: 'ownershipPercentageCalc',
    label: 'Ownership, %',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];

export const identificationsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'identificationTypeDesc',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'identificationIssuer',
    label: 'Issuer',
    sortable: false,
  },
  {
    name: 'identificationNumber',
    label: 'Number',
    sortable: false,
  },
  {
    name: 'administrativeUnitName',
    label: 'Country',
    sortable: false,
  },
  {
    name: 'isoStandard',
    label: 'ISO',
    sortable: false,
  },
  {
    name: 'issueDateValue',
    label: 'Issue Date',
    sortable: false,
  },
  {
    name: 'expirationDateValue',
    label: 'Expiration',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];

export const relationshipsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'groupDesc',
    label: 'Group',
    sortable: false,
  },
  {
    name: 'relationshipDesc',
    label: 'Description',
    sortable: false,
  },
  {
    name: 'ownershipPercentage',
    label: 'Ownership, %',
    sortable: false,
  },
  {
    name: 'entityRelationshipGUID',
    label: 'RelatedEntityGUID',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];

export const soesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'isActive',
    label: 'Status',
    sortable: false,
  },
  {
    name: 'domains',
    label: 'Domains',
    sortable: false,
  },
  {
    name: 'subCategories',
    label: 'Subcategories',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];
